import {
  OPEN_CHANGE,
  TOASTER_ADD_DANGER,
  TOASTER_ADD_INFO,
  TOASTER_ADD_SUCCESS,
  TOASTER_ADD_WARNING,
  TOASTER_HIDE,
  TOASTER_READ,
  TOASTER_REMOVE,
  TOASTER_REMOVE_ALL,
} from './constants';

import { Map as ImmutableMap, List, Record } from 'immutable';

import shortid from 'shortid';

const InitialState = Record({
  messages: new List(),
  openMenu: false,
});

const initialState = new InitialState();

export default function notifications(
  state = initialState,
  action = undefined,
) {
  switch (action.type) {
    case TOASTER_REMOVE_ALL:
      return new InitialState();
    case TOASTER_READ: {
      return state.update('messages', (messages) =>
        messages.take(10).map((message) => message.set('read', true)),
      );
    }
    case TOASTER_REMOVE: {
      const foundIndex = state.messages.findIndex(
        (message) => message.get('hash') === action.payload.key,
      );
      if (foundIndex > -1) {
        return state.deleteIn(['messages', foundIndex]);
      }
      return state;
    }
    // return state.deleteIn(['messages', action.payload.key]);
    case TOASTER_HIDE: {
      const { hash, read } = action.payload;
      const foundIndex = state.messages.findIndex(
        (message) => message.get('hash') === hash,
      );
      if (foundIndex > -1) {
        return state
          .setIn(['messages', foundIndex, 'show'], false)
          .setIn(['messages', foundIndex, 'read'], read);
      }
      return state;
    }
    case TOASTER_ADD_SUCCESS: {
      const hash = shortid.generate();
      return state.update('messages', (messages) =>
        messages.unshift(
          new ImmutableMap({
            ...action.payload,
            hash,
            type: 0,
            time: new Date(),
            show: true,
            read: false,
          }),
        ),
      );
    }
    case TOASTER_ADD_INFO: {
      const hash = shortid.generate();
      return state.update('messages', (messages) =>
        messages.unshift(
          new ImmutableMap({
            ...action.payload,
            hash,
            type: 10,
            time: new Date(),
            show: true,
            read: false,
          }),
        ),
      );
    }
    case TOASTER_ADD_WARNING: {
      const hash = shortid.generate();
      return state.update('messages', (messages) =>
        messages.unshift(
          new ImmutableMap({
            ...action.payload,
            hash,
            type: 20,
            time: new Date(),
            show: true,
            read: false,
          }),
        ),
      );
    }
    case TOASTER_ADD_DANGER: {
      const hash = shortid.generate();
      return state.update('messages', (messages) =>
        messages.unshift(
          new ImmutableMap({
            ...action.payload,
            hash,
            type: 30,
            time: new Date(),
            show: true,
            read: false,
          }),
        ),
      );
    }
    case OPEN_CHANGE: {
      return state.set('openMenu', action.payload);
    }
    default:
      return state;
  }
}
